import Router from 'next/router';
import {INextHistoryState, TBeforePopStateCallback} from 'core/types';

export type TMakeHistoryChangeListeners = () => (
    listenerCallback: TBeforePopStateCallback,
) => (disposerCallback: TBeforePopStateCallback) => void;
export const makeHistoryChangeListeners: TMakeHistoryChangeListeners = () => {
    const callbackList = new Set<TBeforePopStateCallback>();

    return (listenerCallback) => {
        callbackList.add(listenerCallback);

        const onBeforePopState = (state: INextHistoryState) => {
            callbackList.forEach((cb) => cb(state));

            return true;
        };

        Router.beforePopState(onBeforePopState);

        return (disposerCallback) => {
            callbackList.delete(disposerCallback);

            Router.beforePopState(onBeforePopState);
        };
    };
};

export const onHistoryChange = makeHistoryChangeListeners();
